<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-01 14:50:38
 * @LastEditTime: 2019-08-26 15:20:47
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="content">
    <div class="pageTitle">商品上架</div>
    <div class="formArea">
      <el-form ref="form" :model="form" :rules="rules" label-width="160px">
        <el-form-item label="选择经销商/门店:" prop="sn">
          <el-col :span="4">
            <el-input v-model="form.sn" readonly></el-input>
          </el-col>
          <el-col class="line" :span="1" style="text-align: center">-</el-col>
          <el-col :span="8">
            <el-input v-model="form.shop_name" readonly></el-input>
          </el-col>
          <el-col :span="4" style="margin-left: 20px">
            <el-button
              type="primary"
              @click="selectRoleDialog=!selectRoleDialog"
              v-if="!$route.query.edit"
            >选择</el-button>
          </el-col>
        </el-form-item>
        <el-row>
          <div class="specify">
            <el-col>
              <el-form-item label="选择商品:">
                <!-- <el-button type="primary" @click="selectProduct=!selectProduct" style='margin-bottom:15px;'>添加商品</el-button> -->
                <div class="productBox">
                  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                    <el-tab-pane label="非赠品" name="first">
                      <el-tabs v-model="first_active" @tab-click="handleClickfirst">
                        <el-tab-pane
                          :label="value.attribute_name"
                          :name="'attr-'+value.attribute_id"
                          v-if="is_show_attribute||index==0"
                          v-for="(value,index) in attrList"
                          :key="index"
                        ></el-tab-pane>
                        <!-- <el-tab-pane label="优惠品" name="second" v-if='is_show_attribute'></el-tab-pane> -->
                      </el-tabs>
                    </el-tab-pane>
                    <el-tab-pane label="赠品" name="second"></el-tab-pane>
                  </el-tabs>
                  <!--表格-->
                  <el-button
                    type="primary"
                    @click="selectProduct=!selectProduct"
                    style="margin-bottom:15px;"
                  >添加商品</el-button>

                  <div class="searchWord">
                    <el-input
                      v-model="search"
                      style="display: inline-block;width: 300px;margin-bottom:20px;margin-right:10px;"
                      placeholder="产品编号,产品名称,规格"
                    ></el-input>
                    <el-button @click="searchTable" type="primary">搜索</el-button>
                  </div>
                  <el-table
                    ref="multipleTable"
                    :data="tables"
                    v-loading="loading"
                    @selection-change="handleSelectionChange"
                    border
                    stripe
                    fit
                    style="width: 100%"
                  >
                    <el-table-column prop="production_batch" label type="selection" fixed></el-table-column>
                    <el-table-column prop="product_sn" label="产品编号"></el-table-column>
                    <el-table-column prop="product_name" label="产品名称"></el-table-column>

                    <el-table-column prop="product_specs" label="产品规格"></el-table-column>
                    <el-table-column prop="product_price" label="价格">
                      <template slot-scope="scope" class="input">
                        <el-form-item prop>
                          <div v-if="!scope.row.price">
                            <el-input v-model="scope.row.product_price" type="number"></el-input>元
                          </div>
                          <div v-else>
                            <el-input v-model="scope.row.price" type="number"></el-input>元
                          </div>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column prop="product_price" label="失效时间">
                      <template slot-scope="scope" class="input">
                        <el-date-picker
                          v-model="scope.row.expire_time"
                          type="datetime"
                          placeholder="到失效时间后自动删除，非必填" 
                          style="width:270px;"
                          >
                        </el-date-picker>
                      </template>
                    </el-table-column>
                    <el-table-column prop label="操作" width="180" fixed="right">
                      <template slot-scope="scope">
                        <el-button type="text" size="small" @click="del(scope.row,index)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-button type="primary" size="small" @click="delAll()">批量删除</el-button>
                </div>
              </el-form-item>
            </el-col>
          </div>
        </el-row>
      </el-form>
      <el-button type="primary" @click="save('form')">保存</el-button>
    </div>
    <selectProducts
      v-if="selectProduct"
      v-on:handleClose=" selectProduct = false"
      @pushData="select"
    />
    <selectRole
      v-if="selectRoleDialog"
      v-on:handleClose=" selectRoleDialog = false"
      @pushData="role"
    />
  </div>
</template>

<script>
import selectRole from "./selectRole";
import selectProducts from "./selectProducts";

export default {
  data() {
    return {
      search: "",
      loading: false,
      activeName: "first",
      second_active: "first",
      first_active: "",
      form: {
        sn: ""
      },

      tableData: [],
      selectProduct: false,
      selectRoleDialog: false,
      rules: {
        sn: [{ required: true, message: "请选择经销商/门店", trigger: "blur" }],
        price: [
          { required: true, message: "金额不能为空" },
          { type: "number", message: "金额必须为数字值" }
        ]
      },
      isgiftData1: [],
      istgiftData1: [],
      isgiftData0: [],
      istgiftData0: [],
      pageNo2: 1, //页码
      pageSize2: 5, //每页现实的条数
      totalSize2: 0, //总条数
      type: 2,
      flag: 1, //组合表示 1 2 3 4
      isgift: [],
      istgift: [],
      is_show_attribute: 1,
      tables: [],
      attrList: [],
      multipleSelection: [] //多选数组
    };
  },

  computed: {
    // 模糊搜索
    tablesa() {
      return this.tableData;
      const search = this.search;
      if (search) {
        // filter() 方法创建一个新的数组，新数组中的元素是通过检查指定数组中符合条件的所有元素。
        // 注意： filter() 不会对空数组进行检测。
        // 注意： filter() 不会改变原始数组。
        return this.tableData.filter(data => {
          // some() 方法用于检测数组中的元素是否满足指定条件;
          // some() 方法会依次执行数组的每个元素：
          // 如果有一个元素满足条件，则表达式返回true , 剩余的元素不会再执行检测;
          // 如果没有满足条件的元素，则返回false。
          // 注意： some() 不会对空数组进行检测。
          // 注意： some() 不会改变原始数组。
          return Object.keys(data).some(key => {
            // indexOf() 返回某个指定的字符在某个字符串中首次出现的位置，如果没有找到就返回-1；
            // 该方法对大小写敏感！所以之前需要toLowerCase()方法将所有查询到内容变为小写。
            return (
              String(data[key])
                .toLowerCase()
                .indexOf(search) > -1
            );
          });
        });
      }
      return this.tableData;
    }
  },
  methods: {
    init() {
      if (this.$route.query.edit) {
        var url = "/specify.putaways/" + this.$route.query.edit;
        this.$get("logistics", url).then(res => {
          this.form.sn = res.data.sn;
          this.form.shop_name = res.data.name;
          this.isgift = res.data.products[0].products;
          this.istgift = res.data.products[1].products;
          // 结构重组
          // array.forEach(element => {

          // });
          this.isgiftData0 = this.isgift;
          if (this.is_show_attribute == 1) {
            this.istgift.forEach(element => {
              // if(element.attribute_id&&Number(element.attribute_id)==0){
              //       this.istgiftData1.push(element)
              //   }else{
              //       this.istgiftData0.push(element)
              //   }
              this["tablesattr-" + element.attribute_id].push(element);
            });
          } else {
            this.tables = this.istgift;
          }

          this.tabType();
        });
      }
      // 获取配置信息
      // this.$get('logistics','/configs.order').then(res=>{
      //       this.is_show_attribute=res.data.product_attribute_on_off
      //   })
    },
    // 表格搜索
    searchTable() {
      const search = this.search;
      if (search != "") {
        // filter() 方法创建一个新的数组，新数组中的元素是通过检查指定数组中符合条件的所有元素。
        // 注意： filter() 不会对空数组进行检测。
        // 注意： filter() 不会改变原始数组。
        var table = this.tableData;
        this.tables = table.filter(data => {
          // some() 方法用于检测数组中的元素是否满足指定条件;
          // some() 方法会依次执行数组的每个元素：
          // 如果有一个元素满足条件，则表达式返回true , 剩余的元素不会再执行检测;
          // 如果没有满足条件的元素，则返回false。
          // 注意： some() 不会对空数组进行检测。
          // 注意： some() 不会改变原始数组。
          return Object.keys(data).some(key => {
            // indexOf() 返回某个指定的字符在某个字符串中首次出现的位置，如果没有找到就返回-1；
            // 该方法对大小写敏感！所以之前需要toLowerCase()方法将所有查询到内容变为小写。
            return (
              String(data[key])
                .toLowerCase()
                .indexOf(search) > -1
            );
          });
        });
      } else {
        this.tables = this.tableData;
      }
    },
    role(value) {
      this.type = value.dealer_sn ? 2 : 3;
      this.form.sn = value.dealer_sn ? value.dealer_sn : value.shop_sn;
      this.form.shop_name = value.shop_name
        ? value.shop_name
        : value.dealer_name;
      // this.getProductList()
    },
    select(value) {
      if (this.activeName == "first" && this.is_show_attribute == 1) {
        this["tables" + this.first_active].push(value);
      } else if (this.activeName == "first") {
        this.isgiftData1.push(value);
      }

      if (this.activeName == "second") {
        this.isgiftData0.push(value);
      }
      this.tabType();
    },
    handleClick(value) {
      this.tabType();
    },
    handleClickfirst(value) {
      this.tabType();

      if (!this.$route.query.edit) {
        this.tabType();
      }
    },
    handleClicksecond(value) {
      this.tabType();

      if (!this.$route.query.edit) {
        this.tabType();
      }
    },
    handleSizeChange2(value) {},
    handleCurrentChange2(value) {},
    getAttr() {
      this.$get("logistics", "/configs.order").then(res => {
        if (res.data.product_attribute_on_off == 1) {
          this.is_show_attribute = 1;
          this.$get("logistics", "/product.attributes").then(res => {
            this.attrList = res.data;
            res.data.forEach(element => {
              if (element.is_default == 1) {
                this.first_active = "attr-" + element.attribute_id;
              }
              this["tablesattr-" + element.attribute_id] = [];
            });
            this.init();
          });
        } else {
          this.is_show_attribute = 0;
          this.init();
        }
      });
    },

    // 数组去重
    Unique(arr, name) {
      var hash = {};
      return arr.reduce(function(item, next) {
        hash[next[name]] ? "" : (hash[next[name]] = true && item.push(next));
        return item;
      }, []);
    },
    // 根据不同的TAB 渲染不同的数据
    tabType() {
      this.tables = [];
      // 一共四种 组合  分别定义为 1 2 3 4
      if (this.activeName == "first" && this.is_show_attribute == 1) {
        console.log("a");
        this["tables" + this.first_active] = this.Unique(
          this["tables" + this.first_active],
          "product_sn"
        );
        // this.istgiftData0=
        this.tableData = this["tables" + this.first_active];
        this.tables = this["tables" + this.first_active];
        //  this.flag=1
      } else if (this.activeName == "first") {
        console.log("b");

        this.tables = this.Unique(this.isgiftData1, "product_sn");
        this.tableData = this.tables;
      }
      if (this.activeName == "second") {
        console.log("c");

        this.isgiftData0 = this.Unique(this.isgiftData0, "product_sn");
        this.tableData = this.isgiftData0;
        this.tables = this.isgiftData0;

        // this.flag=3
      }



    },
    del(value) {
      if (this.activeName == "first") {
        if (this.is_show_attribute == 1) {
          this.delSort(this["tables" + this.first_active], value);
        } else {
          this.delSort(this.isgiftData1, value);
        }
      } else {
        this.delSort(this.isgiftData0, value);
      }
      this.tabType();
    },
    // 删除数组某项的方法
    delSort(_arr, _obj) {
      var len = _arr.length;
      for (var i = 0; i < len; i++) {
        if (_arr[i] == _obj) {
          _arr.splice(i, 1);
        }
      }
      return _arr;
    },
    getProductList() {
      var url = "/specify.putaways/" + this.form.sn;
      this.$get("logistics", url)
        .then(res => {
          // this.tableData
        })
        .catch(error => {
          this.$message.error({
            message: error.message
          });
        });
    },
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var temp = [],
            check = "";
          if (this.is_show_attribute == 1) {
            this.attrList.forEach(element => {
              // this['tablesattr-'+element.attribute_id].attribute_id=element.attribute_id
              this["tablesattr-" + element.attribute_id].forEach(v => {
                if (!v.price && !v.product_price) {
                  check = element.attribute_id;
                }
                v.attribute_id = element.attribute_id;
                temp.push(v);
              });
              //  temp= temp.concat(this['tablesattr-'+element.attribute_id])
            });
          } else {
            temp = [...this.isgiftData1];
          }
          if (check != "") {
            this.first_active = "tablesattr-" + check;
            this.$message.error({
              message: "商品价格必须大于0"
            });
            return;
          }
          // [...this.istgiftData0,...this.istgiftData1]
          var temp1 = [...this.isgiftData0];
          // console.log(temp)
          // return;
          var temSecond = [
            {
              isgift: 1,
              products: []
            },
            {
              isgift: 2,
              products: []
            }
          ]; //重新组织 结构  分成两个字段  isgift  products
          temp.forEach(element => {
            console.log(element)
            temSecond[1].products.push({
              attribute_id: element.attribute_id ? element.attribute_id : "",
              product_sn: element.product_sn,
              product_name: element.product_name,
              expire_time: this.imeFormat(element.expire_time),
              price: element.price ? element.price : element.product_price
            });
          });
          temp1.forEach(element => {
            temSecond[0].products.push({
              attribute_id: element.attribute_id ? element.attribute_id : "",
              product_sn: element.product_sn,
              product_name: element.product_name,
              expire_time: this.imeFormat(element.expire_time),
              price: element.price ? element.price : element.product_price
            });
          });
          // 修改
          if (this.$route.query.edit) {
            var url = "/specify.putaways/" + this.$route.query.edit;
            this.$put("logistics", url, {
              _method: "PUT",
              products: JSON.stringify(temSecond)
            })
              .then(res => {
                this.$message({
                  type: "info",
                  message: "修改成功"
                });
                this.$router.push({ name: "goodsOnput" });
              })
              .catch(error => {
                this.$message.error({
                  message: error.message
                });
              });
          } else {
            // 新增
            this.$post("logistics", "/specify.putaways", {
              type: this.type,
              sn: this.form.sn,
              products: JSON.stringify(temSecond)
            })
              .then(res => {
                this.$message({
                  type: "info",
                  message: "添加成功"
                });
                setTimeout(() => {
                  this.$router.go(-1);
                }, 200);
              })
              .catch(error => {
                this.$message.error({
                  message: error.message
                });
              });
          }
        } else {
          return false;
        }
      });
    },
    imeFormat(Time){
        if(!Time) return '';
        var time = new Date(Time);
        var year = time.getFullYear();
        var month = time.getMonth()+1;
        var date = time.getDate();
        var hours = time.getHours();
        var minutes = time.getMinutes();
        var seconds = time.getSeconds();
        function add0(m){return m<10?'0'+m:m }
        var startTime = add0(year) + '-' + add0(month) + '-' + add0(date) + ' ' + add0(hours) + ':' + add0(minutes) + ':' + add0(seconds)
        return startTime
    },
    formatToArray(Time){
      if( !Time ) return '';

    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    delAll() {
      if (this.activeName == "first") {
        if (this.is_show_attribute == 1) {
          this.multipleSelection.forEach(element => {
            this.delSort(this["tables" + this.first_active], element);
          });
        } else {
          this.multipleSelection.forEach(element => {
            this.delSort(this.isgiftData1, element);
          });
        }
      } else {
        this.multipleSelection.forEach(element => {
          this.delSort(this.isgiftData0, element);
        });
      }
      this.tabType();
    }
  },
  created() {
    // this.getProductList()
    this.getAttr();

    this.init();
  },
  components: {
    selectProducts,
    selectRole
  }
};
</script>

<style lang="scss" scoped>
.productBox {
  border: 1px solid #eee;
  padding: 15px;
}
.specify {
  /deep/ tbody tr {
    height: 70px;
    .cell {
      overflow: visible;
      .el-input {
        width: 50%;
        display: inline-block;
      }
    }
  }
}
</style>


